import React, { PropsWithChildren, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import SessionContext from 'contexts/session';
import PageLoader from 'components/PageLoader';

type NonAuthenticatedRequiredProps = PropsWithChildren<{
  rootPath?: string;
}>;
const NonAuthenticatedRequired = ({
  children,
  rootPath
}: NonAuthenticatedRequiredProps) => {
  const { user, userChecking } = useContext(SessionContext);

  const defaultRootPath = user?.role === 'ADMIN' ? '/admin' : '/';

  return (
    <>
      {userChecking ? (
        <PageLoader />
      ) : user ? (
        <Navigate to={rootPath || defaultRootPath} />
      ) : (
        children
      )}
    </>
  );
};

export default NonAuthenticatedRequired;
